export const LAYOUT = {
  HorizontalPaddings: '--horizontal-paddings',
  VerticalPaddings: '--vertical-paddings',
  /**
   * @todo variables naming need refactor: ComponentPropertyValue, and LAYOT variables  should include only variables for page layout settings, not Grid
   */
  VerticalPageTitlePaddings: '--vertical-page-title-paddings',
  VerticalGridPaddings: '--vertical-grid-paddings',
  VerticalGridTitlePaddings: '--vertical-grid-title-paddings',
  VerticalGridTitleCategoryPaddings: '--vertical-grid-title-category-paddings',
  VerticalRowPaddings: '--vertical-row-paddings',
  VerticalBottomRowPaddings: '--vertical-bottom-row-paddings',
  VerticalBottomSpecialRowPaddings: '--vertical-bottom-special-row-paddings',
  VerticalBottomSpecialSimpleRowPaddings:
    '--vertical-bottom-special-simple-row-paddings',
  VerticalTopRowPaddings: '--vertical-top-row-paddings-default',
  VerticalTopSpecialRowPaddings: '--vertical-top-special-row-paddings-default',
  VerticalTopSpecialSimpleRowPaddings:
    '--vertical-top-special-simple-row-paddings',
  VerticalCardsCategoryPaddings: '--vertical-cards-category-paddings-default',
  LoaderHeight: '--loader-height',
  NavbarSize: '--layout-navbar-size',

  DetailsPageVerticalGridTopOffset:
    '--layout-details-page-vertical-top-grid-offset',
} as const
export type LAYOUT = (typeof LAYOUT)[keyof typeof LAYOUT]

export const PLAYER_LAYOUT = {
  PlayerVerticalPaddingsDefault: '--player-vertical-paddings-default',
  PlayerHorizontalPaddingsDefault: '--player-horizontal-paddings-default',
  PlayerVerticalPaddingsSize10: '--player-vertical-paddings-size-10',
  PlayerHorizontalPaddingsSize10: '--player-horizontal-paddings-size-10',
} as const
export type PLAYER_LAYOUT = (typeof PLAYER_LAYOUT)[keyof typeof PLAYER_LAYOUT]
